import { fetchData } from './fetchData';
import { DefaultResponseData } from './data/DefaultResponseData';

export type ChangePasswordRequestData = {
    // 1:修改密碼/2:忘記密碼
    type: '1',
    login: string,
    password: string,
    password_bef: string,
};

export type ResetPasswordRequestData = {
    // 1:修改密碼/2:忘記密碼
    type: '2',
    login: string,
    password: string,
    verify_code: string,
};

function changePassword(data: ChangePasswordRequestData): Promise<DefaultResponseData> {
    return fetchData('api/reset_password', {
        method: 'POST',
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((resData: DefaultResponseData) => resData);
}

function resetPassword(data: ResetPasswordRequestData): Promise<DefaultResponseData> {
    return fetchData('api/reset_password', {
        method: 'POST',
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((resData: DefaultResponseData) => resData);
}

export { changePassword, resetPassword };
